import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { Toast, useToast } from "@oysterhr/ui"
import { useUpsertPaySupplement } from "../../../../../hooks/useUpsertPaySupplement"
import { PayrollChangeFormValues } from "../types"

interface Props {
  close: () => void
  onSuccess: () => void
}

export const useOneTimePayrollChange = ({ close, onSuccess }: Props) => {
  const { t } = useTranslation("Payroll")
  const toast = useToast()
  const [updatePaySupplement] = useUpsertPaySupplement({ handlePayloadErrors: true })

  return useCallback(
    ({ selectedEngagementId, amount, ...values }: PayrollChangeFormValues) => {
      const [year, month] = values.month.split("-").map(Number)
      return updatePaySupplement({
        variables: {
          ...values,
          year,
          month,
          engagementId: `Engagement:${selectedEngagementId}`,
          amount: Number(amount),
        },
      }).then(({ data }) => {
        if (!data?.upsertPaySupplement.errors.length) {
          toast({
            render: (
              <Toast variation="success">
                <Toast.Content>{t("form.addSuccess")}</Toast.Content>
              </Toast>
            ),
          })
          onSuccess()
        }
        close()
      })
    },
    [close, onSuccess, toast, t, updatePaySupplement],
  )
}
